import { Image } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useAssetResolver } from "../content-management/ContentManagementProvider";
export const PimcoreImageDisplay = (props) => {
    const [imageUrl, setImageUrl] = useState("");
    const resolver = useAssetResolver();
    useEffect(() => {
        resolver(props.assetId, "WebLarge").then((asset) => { var _a; return setImageUrl((_a = asset === null || asset === void 0 ? void 0 : asset.url) !== null && _a !== void 0 ? _a : ""); });
    }, [props.assetId]);
    return (React.createElement(Image, Object.assign({}, props, { src: imageUrl, alt: props.alt })));
};
